<template>
  <v-main>
    <v-container fluid>
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

      <v-card>
        <v-card-title>
          Jadwal Praktek Dokter
          <v-spacer></v-spacer>

          <v-btn color="purple" dark class="mb-2" @click="doAdd">
            Tambah
          </v-btn>

          <v-dialog v-model="dialog" persistent max-width="600">
            <v-card>
              <v-card-title>
                <span class="text-h5">Jadwal Praktek Dokter</span>
              </v-card-title>
              <v-card-text>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                  class="pl-4 pr-4 pt-4"
                >
                  <v-row>
                    <v-col cols="12">
                      <v-combobox
                        v-model="currentData.selectedKlinik"
                        label="Klinik"
                        clearable
                        dense
                        outlined
                        :items="items_klinik"
                        item-text="value"
                        item-value="code"
                        :rules="currentData.klinikRules"
                      ></v-combobox>
                    </v-col>
                    <v-col cols="12">
                      <v-combobox
                        v-model="currentData.selectedPoli"
                        label="Poli"
                        clearable
                        dense
                        outlined
                        :items="items_poli"
                        item-text="nama"
                        item-value="id"
                        :rules="currentData.poliRules"
                      ></v-combobox>
                    </v-col>
                    <v-col cols="12">
                      <v-combobox
                        v-model="currentData.selectedHari"
                        label="Hari"
                        clearable
                        dense
                        outlined
                        :items="items_hari"
                        item-text="value"
                        item-value="code"
                        :rules="currentData.hariRules"
                      ></v-combobox>
                    </v-col>
                    <v-col cols="12">
                      <v-combobox
                        v-model="currentData.selectedDokter"
                        label="Dokter"
                        clearable
                        dense
                        outlined
                        :items="items_dokter"
                        item-text="nama"
                        item-value="id"
                        :rules="currentData.dokterRules"
                      ></v-combobox>
                    </v-col>
                    <v-col cols="12">
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-text-field
                            v-model="currentData.jam_awal"
                            label="Jam Awal"
                            type="time"
                            dense
                            outlined
                            :rules="currentData.jamAwalRules"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                            v-model="currentData.jam_akhir"
                            label="Jam Akhir"
                            type="time"
                            dense
                            outlined
                            :rules="currentData.jamAkhirRules"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = false">
                  Close
                </v-btn>
                <v-btn color="blue darken-1" text @click="doSave"> Save </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5"
                >Apa anda akan menghapus data ini?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Tidak</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                  >Ya</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card-title>

        <v-row class="mx-4 my-4">
          <v-col cols="12" sm="4" md="4">
            <v-combobox
              v-model="selectedHari"
              label="Hari"
              clearable
              dense
              outlined
              :items="items_hari"
              item-text="value"
              item-value="code"
              @change="changeHari"
            ></v-combobox>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-combobox
              v-model="selectedKlinik"
              label="Klinik"
              clearable
              dense
              outlined
              :items="items_klinik"
              item-text="value"
              item-value="code"
              @change="changeKlinik"
            ></v-combobox>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-combobox
              v-model="selectedPoli"
              label="Poli"
              clearable
              dense
              outlined
              :items="items_poli"
              item-text="nama"
              item-value="id"
              @change="changePoli"
            ></v-combobox>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-combobox
              v-model="selectedDokter"
              label="Dokter"
              clearable
              dense
              outlined
              :items="items_dokter"
              item-text="nama"
              item-value="id"
              @change="changeDokter"
            ></v-combobox>
          </v-col>
        </v-row>

        <v-data-table
          :headers="headers"
          :items="list_data"
          :options.sync="options"
          :server-items-length="totalData"
          :loading="loading"
          class="elevation-1"
        >
          <template #[`item.jam_awal`]="{ item }">
            <div>{{ item.jam_awal }} - {{ item.jam_akhir }}</div>
          </template>

          <template #[`item.actions`]="{ item }">
            <v-icon medium class="mr-3" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon medium @click="deleteItem(item)"> mdi-delete </v-icon>
          </template>
          <template #[`item.foto_url`]="{ item }">
            <v-responsive v-if="item.foto_url_original">
              <v-img :src="item.foto_url" contain width="100"></v-img>
            </v-responsive>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import JadwalPraktekDokterService from "../services/JadwalPraktekDokterService";
import PoliService from "../services/PoliService";
import CommonService from "../services/CommonService";
import MasterService from "../services/MasterService";
import NakesService from "../services/NakesService";

export default {
  data: () => ({
    valid: true,
    breadcrumbs: [
      {
        text: "Data Jadwal Praktek Dokter",
        disabled: true,
        href: "breadcrumbs_dashboard",
      },
    ],
    search: "",
    selectedHari: "",
    selectedPoli: "",
    selectedKlinik: "",
    selectedDokter: "",
    headers: [
      {
        text: "No",
        align: "start",
        sortable: false,
        value: "no",
      },
      { text: "Klinik", value: "nama_klinik_type", sortable: false },
      { text: "Poli", value: "nama_poli", sortable: false },
      { text: "Hari", value: "nama_hari", sortable: false },
      { text: "Dokter", value: "nama_dokter", sortable: false },
      { text: "Jam", value: "jam_awal", sortable: false },
      { text: "Actions", value: "actions", sortable: false },
    ],
    isFirst: false,
    totalData: 0,
    list_data: [],
    loading: true,
    options: {
      itemsPerPage: 10,
    },

    editedIndex: -1,
    editedItem: {},
    dialog: false,
    dialogDelete: false,

    currentData: {
      id: null,
      selectedKlinik: null,
      selectedPoli: null,
      selectedHari: null,
      selectedDokter: null,
      jam_awal: null,
      jam_akhir: null,
      nama: "",
      alamat: "",
      phone: "",
      google_map_location: "",
      foto_url: null,
      fileKey: 0,
      FotoUrl: "",
      fotoKey: 0,
      klinikRules: [(v) => !!v || "Klinik harus diisi"],
      poliRules: [(v) => !!v || "Poli harus diisi"],
      hariRules: [(v) => !!v || "Hari harus diisi"],
      dokterRules: [(v) => !!v || "Dokter harus diisi"],
      jamAwalRules: [(v) => !!v || "Jam Awal harus diisi"],
      jamAkhirRules: [(v) => !!v || "Jam Akhir harus diisi"],
    },

    items_hari: [],
    items_poli: [],
    items_klinik: [],
    items_dokter: [],
  }),
  watch: {
    options: {
      handler() {
        if (this.isFirst) {
          this.getDataFromApi();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getDataFromApi();
    this.getListHari();
    this.getListPoli();
    this.getListKlinikType();
    this.getListNakes();
  },
  methods: {
    getDataFromApi() {
      const { page, itemsPerPage } = this.options;

      let hari = "";
      let poli = "";
      let klinik = "";
      let dokter = "";

      if (this.selectedHari) {
        hari = this.selectedHari.code;
      }

      if (this.selectedPoli) {
        poli = this.selectedPoli.id;
      }

      if (this.selectedKlinik) {
        klinik = this.selectedKlinik.code;
      }

      if (this.selectedDokter) {
        dokter = this.selectedDokter.id;
      }

      this.loading = true;
      JadwalPraktekDokterService.jadwalList(
        page,
        itemsPerPage,
        this.search,
        hari,
        poli,
        klinik,
        dokter,
      )
        .then((res) => {
          this.list_data = res.data.list_data;
          this.totalData = res.data.total;
          this.loading = false;
          this.isFirst = true;
        })
        .catch((err) => {
          this.loading = false;
          this.isFirst = true;
          console.log(err);
        });
    },

    changeHari: async function () {
      this.getDataFromApi();
    },

    changePoli: async function () {
      this.getDataFromApi();
    },

    changeKlinik: async function () {
      this.getDataFromApi();
    },

    changeDokter: async function () {
      this.getDataFromApi();
    },

    async getListHari() {
      MasterService.hariList()
        .then((res) => {
          this.items_hari = res.data.list_data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getListPoli() {
      PoliService.poliListAll()
        .then((res) => {
          this.items_poli = res.data.list_data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getListKlinikType() {
      MasterService.klinikTypeList()
        .then((res) => {
          this.items_klinik = res.data.list_data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getListNakes() {
      NakesService.nakesListAll()
        .then((res) => {
          this.items_dokter = res.data.list_data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    doAdd: async function () {
      this.dialog = true;
      this.currentData.id = null;
      this.currentData.nama = "";
      this.currentData.alamat = "";
      this.currentData.phone = "";
      this.currentData.google_map_location = "";
      this.currentData.foto_url = null;
      this.currentData.FotoUrl = null;
    },

    doSave: async function () {
      if (!this.$refs.form.validate()) {
        window.scrollTo(0, 0);
        return;
      }

      if (this.currentData.id != null) {
        JadwalPraktekDokterService.update(this.currentData)
          .then((res) => {
            console.log(res);
            this.dialog = false;
            CommonService.showSuccessToast("Update jadwal berhasil");

            this.getDataFromApi();
          })
          .catch((err) => {
            console.log(err);
            CommonService.showErrorToast("Update jadwal gagal. Coba lagi");
          });
      } else {
        JadwalPraktekDokterService.create(this.currentData)
          .then((res) => {
            console.log(res);
            this.dialog = false;
            CommonService.showSuccessToast("Tambah jadwal berhasil");

            this.getDataFromApi();
          })
          .catch((err) => {
            console.log(err);
            CommonService.showErrorToast("Tambah jadwal gagal. Coba lagi");
          });
      }
    },

    editItem(item) {
      console.log(item);
      this.editedIndex = this.list_data.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.dialog = true;
      this.currentData.id = this.editedItem.id;
      this.currentData.selectedKlinik = null;
      this.currentData.selectedPoli = null;
      this.currentData.selectedHari = null;
      this.currentData.selectedDokter = null;
      this.currentData.jam_awal = this.editedItem.jam_awal;
      this.currentData.jam_akhir = this.editedItem.jam_akhir;

      if (this.editedItem.klinik_type) {
        this.items_klinik.forEach((entry) => {
          if (this.editedItem.klinik_type == entry.code) {
            this.currentData.selectedKlinik = entry;
          }
        });
      }

      if (this.editedItem.poli_dokter_id) {
        this.items_poli.forEach((entry) => {
          if (this.editedItem.poli_dokter_id == entry.id) {
            this.currentData.selectedPoli = entry;
          }
        });
      }

      if (this.editedItem.hari) {
        this.items_hari.forEach((entry) => {
          if (this.editedItem.hari == entry.code) {
            this.currentData.selectedHari = entry;
          }
        });
      }

      if (this.editedItem.user_id) {
        this.items_dokter.forEach((entry) => {
          if (this.editedItem.user_id == entry.id) {
            this.currentData.selectedDokter = entry;
          }
        });
      }
    },

    deleteItem(item) {
      console.log(item);
      this.editedIndex = this.list_data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.closeDelete();

      JadwalPraktekDokterService.delete(this.editedItem.id)
        .then((res) => {
          console.log(res);
          CommonService.showSuccessToast("Hapus jadwal berhasil");

          this.getDataFromApi();
        })
        .catch((err) => {
          console.log(err);

          CommonService.showErrorToast("Hapus jadwal gagal. Coba lagi");
        });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
  },
};
</script>
